import { CheckIcon } from 'assets/images';
import { BaseInput } from 'components/UI/BaseInput';

export const InputValidation = (props) => {
  return (
    <>
      <BaseInput {...props} />
      <img src={CheckIcon} className="claiming-form-icon" alt="" />
    </>
  );
};
